import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';
import userImage from '../assets/128x128.jpg';
import {logo} from '../assets/img/logo-white.png';
/**
 *
 */

const errStyle = {
    color: 'red',
    fontSize: '14',
    textAlign: 'center'
};

class ForgotPassword extends Component {
    constructor(props){
        super(props);

        let urlParams = this.props.location.search.replace('?', '').split('&');
        let params = {};
        for(let i = 0; i < urlParams.length; i++){
            let split_params = urlParams[i].split('=');
            params[split_params[0]] = split_params[1];
        }

        this.state = {
            email: '',
            password: '',
            params: params,
            passwordAgain: '',
            errors: []
        }
    }

    componentDidMount(){
        if(this.props.match.params.access_token){
            //this.props.checkResetToken(this.props.match.params.access_token);
        }else{
            this.props.authClear();
        }
    }

    componentWillUnmount(){
        //this.props.resetPasswordStatus();
    }

    sendPasswordReset = (e) => {
        e.preventDefault();
        this.props.requestPasswordReset(this.state.email);
    }

    resetPassword = (e) => {
        e.preventDefault();
        let hasError = false;
        let {errors} = this.state;
        errors = [];
        if(this.state.password !== this.state.passwordAgain){
            errors.push("Passwords don't match");
            hasError = true;
        }

        if(this.state.password.length < 8){
            errors.push('Password must be at least 8 characters');
            hasError = true;
        }
        if(!hasError){
            this.props.resetPassword(this.props.match.params.access_token, this.state.password);
        }

        this.setState({errors});
    }
    render(){

        const {errorMessage} = this.props;

        if(this.props.passwordResetCompleted){

            return (
                <div className="user-login-signup-wrap">
                <div className="ulsw-left-wrap">
                    <div className="ulsw-left">
                        <div className="uslw-top">
                            <div className="logo-wrap">
                                <a href="/login"><img src={logo} alt="99Point9" /></a>    
                            </div>
                        </div>
                        <div className="uslw-middle">
                            <p className="left-content-wrap-head">99point9</p>   
                            <p className="left-content-wrap-description">Personalised learning. Guaranteed scores.</p>
                            <p className="left-content-wrap-details">Introducing: The world's first student-centric, personalised, and content-mastery-focused platform. </p>
                            <div className="button-wrap">
                                <a href="/login">Get Started</a>
                            </div>
                        </div>
                        <div className="uslw-bottom">
                
                        </div>
                    </div>

                </div>
                <div className="ulsw-right-wrap">
                    <div className="ulsw-right">

                        <div className="uslw-box">
                            <div className="extra-top-right">
                                <div>
                                    Don't have an account?
                                </div>
                                <div>
                                    <Link to="/signup" className="btn btn-default">Create Account</Link>
                                </div>
                            </div>
                            <form className="login-form-wrap" onSubmit={e => {
                                e.preventDefault();
                                
                            }
                            }>
                                {this.props.location.pathname.indexOf('configure-') > -1 ?
                                <h1>Finish setting up your account</h1>
                                :
                                 <h1>Reset Password</h1>
                                }
                                <h2>Enter your details below.</h2>
                                
                                
                                <h3>Your password has been reset successfully.  You may now log in.</h3>
                                <div className="form-group">
                                            <Link to="/login" className="btn btn-primary" >Log In</Link>
                                        </div>
                            </form>
                            <div className="ifSafari text-center">
                                <i className="zmdi zmdi-alert"></i>
                                <h3 className="sm-bottom40">Uh oh! The browser you're currently using is not supported.</h3>
                                <p>Please use Google Chrome or Mozilla Firfox browser to access the portal.</p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>    
            )
            
        }


        return (
            <div className="user-login-signup-wrap">
                <div className="ulsw-left-wrap">
                    <div className="ulsw-left">
                        <div className="uslw-top">
                            <div className="logo-wrap">
                                    
                            </div>
                        </div>
                        <div className="uslw-middle">
                            <p className="left-content-wrap-head">99point9</p>   
                            <p className="left-content-wrap-description">Personalised learning. Guaranteed scores.</p>
                            <p className="left-content-wrap-details">Introducing: The world's first student-centric, personalised, and content-mastery-focused platform. </p>
                            <div className="button-wrap">
                                <a href="/login">Get Started</a>
                            </div>
                        </div>
                        <div className="uslw-bottom">
                
                        </div>
                    </div>

                </div>
                <div className="ulsw-right-wrap">
                    <div className="ulsw-right">

                        <div className="uslw-box">
                            <div className="extra-top-right">
                                <div>
                                    Don't have an account?
                                </div>
                                <div>
                                    <Link to="/signup" className="btn btn-default">Create Account</Link>
                                </div>
                            </div>
                            <form className="login-form-wrap" onSubmit={e => {
                                e.preventDefault();
                                
                            }
                            }>
                                {this.props.location.pathname.indexOf('configure-') > -1 ?
                                <h1>Finish setting up your account</h1>
                                :
                                 <h1>Reset Password</h1>
                                }
                                <h2>Enter your details below.</h2>
                                {this.props.match.params.access_token ? 
                                    <div>
                                        <div className="form-group">
                                            <div className="flex flex-justify-content-space-between">
                                                <label>Password</label>
                                                <div className="text-right">
                                                    <a href="/login" className="fg-pass-text">Remember Your Password?</a>
                                                </div>
                                            </div>
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                required
                                                
                                                value={this.state.password}
                                                onChange={({target: {value}}) => this.setState({password: value})}
                                            />

                                            
                                        </div>

                                        <div className="form-group">
                                            <div className="flex flex-justify-content-space-between">
                                                <label>Password (Again)</label>
                                               
                                            </div>
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                required
                                                
                                                value={this.state.passwordAgain}
                                                onChange={({target: {value}}) => this.setState({passwordAgain: value})}
                                            />

                                            
                                        </div>
                                        {
                                                this.state.errors &&
                                                <span className="text-danger">{this.state.errors.map((e, i) => {
                                                    return <p key={i}>{e}</p>
                                                })}</span>
                                            }
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-primary" onClick={e => this.resetPassword(e)}>Reset Password</button>
                                        </div>
                                    </div>

                                    :

                                    <div>
                                        <div className="form-group">
                                            <div className="flex flex-justify-content-space-between">
                                                <label>Email Address</label>
                                                <div className="text-right">
                                                    <a href="forgot-password.php" className="fg-pass-text">Forgot Password?</a>
                                                </div>
                                            </div>
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                required
                                                
                                                value={this.state.email}
                                                onChange={({target: {value}}) => this.setState({email: value})}
                                            />
                                        </div>
                                        {
                                                errorMessage &&
                                                <span style={errStyle}>{errorMessage}</span>
                                            }
                                        <div className="form-group">
                                        {this.props.passwordResetError ?
                                            <p className="text-center">{this.props.passwordResetError}</p>
                                        : null}
                                        {this.props.message?
                                                <p className="text-center">{this.props.message}</p>
                                            :
                                                this.props.disableButton ?
                                                <button  type="submit" className="btn btn-primary disabled">Sending...</button>
                                                :
                                                <button type="submit" className="btn btn-primary" onClick={e => this.sendPasswordReset(e)}>Reset</button>
                                        }
                                            
                                        </div>
                                    </div>
                                }
                                
                                
                                
                             
                            </form>
                            <div className="ifSafari text-center">
                                <i className="zmdi zmdi-alert"></i>
                                <h3 className="sm-bottom40">Uh oh! The browser you're currently using is not supported.</h3>
                                <p>Please use Google Chrome or Mozilla Firfox browser to access the portal.</p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>    
        )
    }
}

export default withRouter(ForgotPassword);


// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js